export default __webpack_public_path__ + "static/media/add_link_en.515e27ce.png";